import { Button, Container } from '@mui/material';
import { NavLink } from "react-router-dom";
import { useState } from 'react';

import { ILoad } from "../../../types/load";

import { useUserContext } from "../../../contexts/userContext";
import { useListContext } from '../../../contexts/listContext';

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import LoadAddForm from '../../forms/loadAddForm';
import { Icons } from '../../icons';


const LoadAdd = () => {
	const userContext = useUserContext();

	return (
		<div className="hwi-load-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageLoads}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/tils">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Load
						</div>
					</section>
					<section className="management-page-form">
						<LoadAddForm></LoadAddForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default LoadAdd;